import Mutations from '../../odata/mutations';

export default { ...new Mutations('currency'), ...new Mutations('currencies') };
